var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2PosInventoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7502 27.7917L54.3752 31.4167L37.4827 48.3334L26.5835 37.4584L30.2085 33.8334L37.4827 41.0834L50.7502 27.7917Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 45.9167V12.0834H16.9167V19.3334H41.0833V12.0834H45.9167V25.7859L50.75 20.9526V12.0834C50.75 9.42508 48.575 7.25008 45.9167 7.25008H35.815C34.8 4.44675 32.1417 2.41675 29 2.41675C25.8583 2.41675 23.2 4.44675 22.185 7.25008H12.0833C9.425 7.25008 7.25 9.42508 7.25 12.0834V45.9167C7.25 48.5751 9.425 50.7501 12.0833 50.7501H33.06L28.2267 45.9167H12.0833ZM29 7.25008C30.3292 7.25008 31.4167 8.33758 31.4167 9.66675C31.4167 10.9959 30.3292 12.0834 29 12.0834C27.6708 12.0834 26.5833 10.9959 26.5833 9.66675C26.5833 8.33758 27.6708 7.25008 29 7.25008Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0835 45.9168V23H45.9168V25.786L37.4827 34.2443L30.2085 26.9943L19.7443 37.4585L28.2268 45.9168H12.0835Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2PosInventoryWhite);
export default __webpack_public_path__ + "static/media/v2-pos-inventory-white.5f52dae69fe07a019ca90461f9dc89f1.svg";
export { ForwardRef as ReactComponent };